import { createTheme } from 'ag-grid-community';

/** Keep in sync with `portal-ui-table-grid.scss` overlay offset. */
export const PORTAL_UI_TABLE_HEADER_HEIGHT = '3.5em' as const;

/** Structural base theme (`createTheme` ≈ no Quartz/Alpine skin); grid still exposes `--ag-*` where AG styles use them.
 *  `borderWidth: 0` globally resets all borders; targeted borders are re-enabled
 *  via `rowBorder` below or in `portal-ui-table-grid.scss`. */
export const portalTableTheme = createTheme().withParams({
  accentColor: 'rgb(var(--portal-ui-color-primary))',
  backgroundColor: 'transparent',
  borderColor: 'rgb(var(--portal-ui-color-divider-small))',
  borderWidth: 0,
  chromeBackgroundColor: 'transparent',
  fontSize: '1em',
  fontFamily: 'var(--portal-ui-font-family)',
  foregroundColor: 'rgb(var(--portal-ui-color-text))',
  headerBackgroundColor:
    'rgb(var(--portal-ui-color-table-alternating-background))',
  headerHeight: PORTAL_UI_TABLE_HEADER_HEIGHT,
  cellHorizontalPadding: '1em',
  oddRowBackgroundColor:
    'rgb(var(--portal-ui-color-table-alternating-background))',
  rangeSelectionHighlightColor:
    'rgb(var(--portal-ui-color-table-selection-background))',
  rowBorder: {
    color: 'rgb(var(--portal-ui-color-divider-small))',
    style: 'solid',
    width: 1,
  },
  rowHeight: '3em',
  rowHoverColor: 'rgb(var(--portal-ui-color-table-hover-background))',
  selectedRowBackgroundColor:
    'rgb(var(--portal-ui-color-table-selection-background))',
  wrapperBorderRadius: 0,
  headerColumnResizeHandleColor: 'transparent',
  headerColumnResizeHandleWidth: 1,
  headerColumnResizeHandleHeight: '2em',
  focusShadow: 'none',
});
